import { Add, Refresh } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCredentialApi } from "../../api/credentials/credentialApi";
import CustomDrawer from "../../components/drawer/CustomDrawer";
import ConfirmDialog from "../../components/modal/ConfirmDialog";
import CustomTable from "../../components/table/CustomTable";
import TableAction from "../../components/table/tableAction";
import { showSnackbar } from "../../redux/actions/commonAction";
import { getAllCredentials } from "../../redux/actions/credentialAction";
import ManageAccounts from "./manageAccounts";
import TableLoader from "../../components/loader/tableLoader";

const Credentials = () => {
  const dispatch = useDispatch();
  const { globalLoader } = useSelector((state) => state.common);
  const { allCredentials } = useSelector((state) => state.credential);
  const [open, setOpen] = useState(false);
  const [showDialog, setDialog] = useState(false);
  const [selectedCred, setCred] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "credName", label: "Account Name" },
    { field: "accountNumber", label: "Account Number", align: "left" },
    {
      field: "accessKey",
      label: "Access Key",
      align: "left",
      render: () => <Box>********</Box>,
    },
    {
      field: "secretKey",
      label: "Secret Key",
      align: "left",
      render: () => <Box>********</Box>,
    },
    { field: "region", label: "Default Region", align: "left" },
    {
      label: "Actions",
      render: (rowData) => (
        <TableAction
          onEdit={() => handleEdit(rowData)}
          onDelete={() => handleDelete(rowData)}
        />
      ),
    },
  ];

  useEffect(() => {
    fetchData();
    //eslint-disable-next-line
  }, []);

  const fetchData = () => {
    dispatch(getAllCredentials(true));
  };

  const handleEdit = (value) => {
    setCred(value);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDialog(false);
    setCred(null);
  };

  const handleDelete = (value) => {
    setCred(value);
    setDialog(true);
  };

  const onDeleteConfirm = async () => {
    setLoading(true);
    const result = await deleteCredentialApi(selectedCred?.credName);
    setLoading(false);
    if (result) {
      handleClose();
      dispatch(
        showSnackbar({
          message: `${selectedCred?.credName} Deleted Successfully`,
          severity: "success",
          open: true,
        })
      );
      dispatch(getAllCredentials());
    }
  };

  return (
    <Box>
      {globalLoader ? (
        <TableLoader />
      ) : (
        <>
          <Box
            mb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h5" gutterBottom={true}>
              Accounts
            </Typography>
            <Box display="flex" sx={{ gridGap: "12px" }}>
              <Button
                variant="outlined"
                onClick={() => fetchData()}
                startIcon={<Refresh />}
              >
                Refresh
              </Button>
              <Button
                startIcon={<Add />}
                variant="contained"
                onClick={() => setOpen(true)}
              >
                Add Account
              </Button>
            </Box>
          </Box>
          <CustomTable columns={columns} data={allCredentials} />
          <CustomDrawer
            open={open}
            title={
              Boolean(selectedCred) ? "Update Account" : "Create New Account"
            }
            onClose={handleClose}
          >
            <ManageAccounts
              edit={Boolean(selectedCred)}
              defeaultValue={selectedCred}
              onClose={handleClose}
            />
          </CustomDrawer>
          <ConfirmDialog
            loading={loading}
            open={showDialog}
            title="Delete Confirmation"
            type="error"
            content={`Are you sure you want to delete the credential ${selectedCred?.credName}?`}
            onClose={handleClose}
            onClik={onDeleteConfirm}
          />
        </>
      )}
    </Box>
  );
};

export default Credentials;
